// Base prices are in USD (clean architecture)

export const BASE_PRICING = {
  website: {
    name: "Website",
    baseMin: 1200,
    baseMax: 4000,
  },

  mobileApp: {
    name: "Mobile App",
    baseMin: 6000,
    baseMax: 18000,
  },

  webAndApp: {
    name: "Website + Mobile App",
    baseMin: 9000,
    baseMax: 28000,
  },

  customSoftware: {
    name: "Custom Software / Platform",
    baseMin: 15000,
    baseMax: 50000,
  },
};

// Multipliers
export const SIZE_MULTIPLIER = {
  small: 1,
  medium: 1.6,
  large: 2.4,
};

export const DESIGN_MULTIPLIER = {
  basic: 1,
  standard: 1.25,
  premium: 1.5,
};

export const TIMELINE_MULTIPLIER = {
  flexible: 1,
  priority: 1.15,
  urgent: 1.3,
};

// Feature pricing (flat add-ons, USD)
export const FEATURE_COSTS = {
  login: 600,
  socialAuth: 400,
  roles: 500,

  payments: 1200,
  subscriptions: 1500,
  invoices: 700,

  dashboard: 1800,
  notifications: 600,
  search: 800,
  uploads: 500,

  thirdPartyApi: 1000,
  crm: 2000,
  analytics: 600,

  ai: 3500,
  chat: 1200,
  automation: 1500,
};

// Admin & roles
export const ADMIN_COST = 2000;
export const EXTRA_ROLE_COST = 600;
